// extracted by mini-css-extract-plugin
export default {"skillSlider":"carousel_skillSlider__fQuNF"};